// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAvatarPartner_root__2DrqE","rootisSelected":"PlasmicAvatarPartner_rootisSelected__iEF0T","svg__bGfmz":"PlasmicAvatarPartner_svg__bGfmz__iveRU"};